export default __webpack_public_path__ + "static/media/tab-game-black.792afe2c.svg";